import { useFore3hourQuery } from "@/query/forecast-query";
import { formatHour } from "@/utils/time";
import { useMemo } from "react";

// WMO present-weather (ww) codes that have an icon in /images/pheno
const PHENO_CODES = [
  2, 3, 5, 7, 9, 10, 20, 23, 24, 27, 28, 60, 61, 63, 65, 66, 67, 68, 71, 73,
  75, 80, 81, 82, 83, 84, 85, 86, 87, 90, 91, 92, 93, 94, 95, 96, 97,
];

function closestPhenoCode(code: number): number {
  return PHENO_CODES.reduce((closest, current) =>
    Math.abs(current - code) < Math.abs(closest - code) ? current : closest
  );
}

const Fore3hourWidget: React.FC = () => {
  const { data: fore3hour } = useFore3hourQuery();
  const phenoList = useMemo(() => {
    return fore3hour?.map((item) => {
      const night = item.c_hour < 6 || item.c_hour > 20 ? "_night" : "";
      const code = item.c_rr != null ? closestPhenoCode(item.c_rr) : 2;
      return `${code}${night}`;
    });
  }, [fore3hour]);

  if (!fore3hour) {
    return (
      <div className="absolute left-4 bottom-20 z-10 flex gap-4">
        <div className="animate-pulse bg-gray-300 h-24 w-20 rounded-2xl" />
        {/* ...more skeletons */}
      </div>
    );
  }
  return (
    // <div className="absolute left-4 bottom-20 z-10 flex gap-4">
    <div className="absolute left-2 sm:left-4 bottom-16 sm:bottom-20 z-10 flex gap-2 sm:gap-4">
      {fore3hour &&
        fore3hour.map((item, i) => (
          <div
            key={`fore3hour-${item.c_hour}`}
            className="bg-gradient-to-b from-blue-300 to-blue-900 rounded-2xl p-3 text-white text-3xl flex items-center justify-center animate-fade"
          >
            <div>
              <div className="text-3xl drop-shadow">
                {formatHour(item.c_hour)}
              </div>
              <div className="text-5xl font-bold">{item.c_temp}°C</div>
            </div>
            <img
              src={`/images/pheno/${phenoList?.[i]}.svg`}
              alt={`${item.c_hour}`}
              className="h-16"
            />
          </div>
        ))}
    </div>
  );
};
export default Fore3hourWidget;
